import i18next from "i18next";
import * as yup from "yup";

import { getYupLocale } from "@ryde/shared";

yup.setLocale(getYupLocale("landing", i18next.t));

export const yupLanding = yup;
